'use client'
import { useRouter } from 'next/navigation';
import { logout } from "@/app/api";
import { User } from '@/assets/icons';
import { SmartLink } from '@/components/ui';

export function LogOut({ user }: { user: { name: string } | null }) {
    const router = useRouter();
    const handleClick = async () => {
        try {
            const response = await logout();
            if (response.success) {
                router.push(`${process.env.NEXT_PUBLIC_PRIMARY_DOMAIN}`)
                router.refresh();
            }
        } catch (e) {
            console.log('Erro ao fazer logout:', e);
        }
    };

    return (
        <div className="flex items-center justify-center gap-3">
            <div className="hidden sm:flex">
                {user ? (
                    <button className="text-sm" onClick={handleClick}>
                        <p className="font-medium">{user.name}</p>
                        <p className='cursor-pointer hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent'>Sair</p>
                    </button>
                ) :
                    <button className="text-sm" onClick={handleClick}>
                        <p className="font-medium">Carregando ...</p>
                        <p className='cursor-pointer hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent'>Sair</p>
                    </button>
                }
            </div>

            <button className="hidden md:flex" onClick={handleClick}>
                <div className="bg-ochre_accent shadow-xs rounded-full p-1.5">
                    <User className="size-6" />
                </div>
            </button>

            <SmartLink type={"internal"} route={"home"} className="flex md:hidden">
                <div className="bg-ochre_accent shadow-xs rounded-full p-1.5">
                    <User className="size-6" />
                </div>
            </SmartLink>
        </div>
    )
}